/*
 * @Author: 张天昊
 * @Date: 2024-05-23 14:31:20
 * @LastEditTime: 2025-04-24 16:46:32
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @Description:
 * @FilePath: /Gov-Web/Mobile/src/pages/itineraryUniversal/constants.js
 */
export const AuxiliaryInfoTypes = {
  旅行社: 'travelAgency',
  导游: 'guide',
  车辆: 'vehicle'
};

export const TravelAgencyTypes = {
  组团社: 0,
  地接社: 1,
  省外组团社: 2 // 委托社
};

export const TrafficTypes = {
  飞机: '01',
  火车: '02',
  客车: '03',
  轮船: '04',
  小包团用车: '05'
};
export const TrafficStateTypes = {
  未备案: 10,
  备案中: 20,
  已备案: 30
};

export const TrafficConfirmStateType = {
  发送用车申请: 10,
  待确认: 20,
  已确认: 30,
  已拒绝: 40,
  已变更: 50,
  撤回: 60,
  因交通系统故障未确认: 99,
};

export const TouristAgeTypes = {
  成人: 'young',
  老人: 'old',
  儿童: 'child'
};

export const GuideConfirmStateType = {
  确认带团: 1,
  拒绝带团: 2,
  已发送: 3
};

export const CertificateTypes = {
  身份证: 1,
  护照: 2,
  现役军官证: 3,
  士兵证: 4,
  学生证: 5,
  港澳通行证: 6,
  台胞证: 7,
  儿童证: 8,
  残疾证: 9,
  外国人永居证: 10
};

export const TeamTypeMap = new Map([
  ['1', { abbr: '省内游', fullName: '国内游-组团-省内游' }],
  ['2', { abbr: '地接省外', fullName: '国内游-地接省外' }],
  ['3', { abbr: '出省游', fullName: '国内游-组团-出省游' }],
  ['4', { abbr: '入境游', fullName: '入境游' }],
  ['5', { abbr: '港澳游', fullName: '出境游-港澳游' }],
  ['6', { abbr: '边境游', fullName: '出境游-边境游' }],
  ['7', { abbr: '赴台游', fullName: '出境游-赴台游' }],
  ['8', { abbr: '出国游', fullName: '出境游-出国游' }]
]);
export const TeamBusiTypeMap = new Map([
  ['1', '常规团'],
  ['2', '一日游'],
  ['3', '单项委托'],
  ['4', '单项一日游委托']
]);

export const dateStrFormat1 = 'YYYY/MM/DD HH:mm:ss';
export const dateStrFormat2 = 'YYYY/MM/DD HH:mm';
export const dateStrFormat3 = 'YYYY/MM/DD';

export const SCENE_TYPE = {
  团队监管: 'team-supervision',
  旅行社: 'travel-agency',
  导游: 'guide'
};
